<template>
    <v-container>
        <v-flex class="titulo-centro">
            <h2> EMAILS  </h2>

            <div class="risquinho-centro"></div>

        </v-flex>
        <ul>
            <li v-for="e in emails" :key="e[0]">
                {{e[1].email}}
            </li>
        </ul>
    </v-container>
</template>

<script>

    import base from "../plugins/firebase";

    export default {
        name: "Emails",

        data() {
            return{
                emails: [],
                ref: base.database().ref("emails"),
            }
        },

        mounted() {
            this.get()
        },

        methods: {
            get() {
                this.ref.orderByKey().once('value')
                    .then(snapshot => {
                        var result = snapshot.val()
                        if(result != null){
                            this.emails = Object.entries(result)

                            this.emails = this.emails.reverse()
                            console.log(this.emails)
                        }
                    })
            },
        }

    }
</script>

<style scoped>

</style>